var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center mt-4 width_full"},[_c('v-btn',{staticClass:"add-new-btn primary text-white px-6 text-body",attrs:{"large":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }